import React, { useEffect, useState } from "react";
import { EyeOutlined, PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, PlusSquareFilled } from '@ant-design/icons';
import { Divider, Modal, Col, Row, Table, Dropdown, Menu, Button, Form, FormInstance, Input } from 'antd';
import { AlignType } from 'rc-table/lib/interface';

import { SelecionarArquivo } from "../../../components/Documentos/SelecionarArquivo";
import { errorMessage, mostrarInfo } from "../../../utils/messages";
import { IDocumentoCertificadora } from "../Componentes/InterfaceCertificadoras";
import { IChaves } from "../../../Interfaces/Interfaces";
import { hasDocMandatory } from "../Utils/Misc"
import { getDocPdf } from "../../../services/apiDocumentos";
import { hasText } from "../../../utils/utilsFunctions";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";


interface IProps {
  form: FormInstance<any>;
  documentos: IDocumentoCertificadora[];
  setDocumentos: React.Dispatch<React.SetStateAction<IDocumentoCertificadora[]>>;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
}

export interface ICampos {
  visible?: string[];
  default?: string[];
  defaultNumberSelect?: number[];
  required?: number[];
  disabled?: number[];
}

const CertificadorasDocumentos = ({ form, documentos, setDocumentos, manter }: IProps) => {

  const [chave, setChave] = useState<number|undefined>();
  const [fileList, setFileList] = useState<IChaves>();

  const [exibirModalDoc, setExibirModalDoc] = useState(false);
  const [exibirDocCadastrado, setExibirDocCadastrado] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");
  const [campos, setCampos] = useState<ICampos>(); // USADO PARA VERIFICAR OS ATRIBUTOS DOS CAMPOS POR MEIO DE UM JSON.

  let nomeArquivo = "";

  useEffect(() => {
    if (documentos.length === 0) {
      setExibirDocCadastrado("none")
    } else {
      setExibirDocCadastrado("inline")
    }
    // console.log(documentos)
  }, [documentos]);

  useEffect(() => {
    if (chave) {
      setFileList(
        {
          idDocumento: chave,
        },
      );
    }
  }, [chave]);


  useEffect(() => {
    if (manter === 2) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);


  const controleDaGrid = (botao: string) => {
    if (!hasText(form.getFieldValue("nuProcesso"))) {
      mostrarInfo("Não é possível incluir novos documentos", "Processo ainda não informado");
    } else if (hasDocMandatory(documentos) === 1 && (botao === "Contrato Social" || botao === "Estatuto")) {
      mostrarInfo("Erro em documentos", "Um e apenas um documento dentre 'ESTATUTO' e 'CONTRATO SOCIAL' deve ser incluído");
    } else {
      if (botao === "cancelar") {
        setExibirModalDoc(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalDoc(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalDoc(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }
    if (manter === 2) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validarDoc = () => {
    if (!fileList || !fileList.idDocumento) {
      errorMessage("Selecione um arquivo para 'upload'.");
    } else {
      form
        .validateFields([
          "idCertificadoraDocumento",
          //"nmDocumento",//Está bugado e não aceita valor em branco
          "arquivo",
        ])
        .then(() => {
          controleDaGrid("incluir");
          setDadosDocumento();
          // successMessage("Documento Adicionado");
        })
        .catch((error) => {
          errorMessage("Campo obrigatório não preechido ou não validado");
        });
    }
  };

  function setDadosDocumento() {
    setDocumentos([
      ...documentos,
      {
        idCertificadoraDocumento: -1,
        //nmDocumento: form?.getFieldValue("nmDocumento") ? form?.getFieldValue("nmDocumento").toUpperCase() : undefined,
        nmDocumento: nomeArquivo,
        idDocumento: chave,
        documentoChave: fileList,
        statusReg: 1,
        touched: true,
      },
    ]);
    form.resetFields([
      "idCertificadoraDocumento",
      "nmDocumento",
    ]);
    setChave(undefined);
    setFileList(undefined);
  }

   const hasCampo = (campo: string) => {
    return campos?.visible ? campos?.visible?.indexOf(campo) > -1 : false
  };

  const isCampoRequired = (campo: string) => {
    if (campos?.visible !== undefined) {
      let idx = campos?.visible?.indexOf(campo)
      if (idx > - 1) {
        return campos?.required ? (campos?.required?.[idx] === 1 ? true : false) : false
      }
    } else {
      return false
    }
  };

  const isCampoDisabled = (campo: string) => {
    if (campos?.visible !== undefined) {
      let idx = campos?.visible?.indexOf(campo)
      if (idx > - 1) {
        return campos?.disabled ? (campos?.disabled?.[idx] === 1 ? true : false) : false
      }
    } else {
      return false
    }
  };

  const campoDefaultValue = (campo: string) => {
    if (campos?.visible !== undefined) {
      let idx = campos?.visible?.indexOf(campo)
      if (idx > - 1) {
        if (campos?.default && campos?.default?.[idx] && campos?.default?.[idx] !== "null") {
          if (campo === "nuDocumento") form?.setFieldsValue({ nuDocumento: campos?.default?.[idx] });
          if (campo === "nmOrgaoExpedidor") form?.setFieldsValue({ nmOrgaoExpedidor: campos?.default?.[idx] });
          return campos?.default?.[idx];
        }
      }
    }
    return undefined;
  };

  const columns = [
    {
      key: "1",
      title: "Nome do Documento",
      dataIndex: "",
      render: (IDoc: IDocumentoCertificadora) => <>{IDoc.nmDocumento}</>,
    },
    {
      // Apenas Marca ou desmarca o campo ativo. Não existe a opção de alteração de documento. Somente exclusão e inclusão de um novo.
      key: "9",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IDoc: IDocumentoCertificadora) => (
        <div style={{ display: manter === 9 ? "none" : exibirElementoAcaoAlteracao }}>
          <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
            <DeleteOutlined
              title="Excluir documento ainda não gravado na base."
              style={{ color: "red", display: (IDoc?.idCertificadoraDocumento && IDoc?.idCertificadoraDocumento < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
              onClick={() => {
                setDocumentos(documentos.filter((doc) => doc !== IDoc));
              }}
            />
          </div>

          <div style={{ display: (IDoc?.idCertificadoraDocumento && IDoc?.idCertificadoraDocumento > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
            <>
              <PlusSquareFilled
                title="Desmarcar para exclução/inativação"
                style={{ color: "blue", display: (IDoc?.statusReg === 1 || IDoc?.statusReg === undefined) ? "none" : "inline" }}
                onClick={() => {
                  IDoc.statusReg = IDoc.statusReg === 1 ? 2 : 1;
                  IDoc.touched = true;
                  setDocumentos(pre => {
                    return pre.map(doc => {
                      if (doc.idCertificadoraDocumento === IDoc.idCertificadoraDocumento) {
                        return IDoc;
                      } else {
                        return doc;
                      }
                    });
                  });
                }}
              />
              <DeleteOutlined
                title="Marcar para exclução/inativação"
                style={{ color: "red", display: (IDoc?.statusReg === 1 || IDoc?.statusReg === undefined) ? "inline" : "none" }}
                onClick={() => {
                  IDoc.statusReg = (IDoc.statusReg === 1 ? 2 : 1);
                  IDoc.touched = true;
                  setDocumentos(pre => {
                    return pre.map(doc => {
                      if (doc.idCertificadoraDocumento === IDoc.idCertificadoraDocumento) {
                        return IDoc;
                      } else {
                        return doc;
                      }
                    });
                  });
                }}
              />
            </>

          </div>
        </div>
      ),
    },
    {
      key: "111", // PARA ARQUIVOS JÁ SALVOS NA TABELA DE DOCUMENTOS ARQUIVOS
      title: "Arquivo",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IDoc: IDocumentoCertificadora) => (
        <Button
          id="arquivo"
          shape="round"
          icon={<EyeOutlined />}
          htmlType="button"
          onClick={() => {
            getDocPdf(IDoc.idDocumento!);
          }}
        />
      ),
    },
  ];

  let jsonDropdownMenu = [
    {
      "key": "1",
      "buttonName": "Estatuto",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Estatuto"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
    {
      "key": "2",
      "buttonName": "Contrato Social",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Contrato Social"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
    {
      "key": "3",
      "buttonName": "Comprovante de Experiência",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Comprovante de experiência de, no mínimo três anos na emissão do certificado"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
    {
      "key": "4",
      "buttonName": "Modelo do Certificado Emitido",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Modelo do certificado emitido"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
    {
      "key": "5",
      "buttonName": "Declaração de Independência/Inexistência",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Declaração de independência e de inexistência de conflito de interesses em relação à EFPC"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
    {
      "key": "6",
      "buttonName": "Nota Técnica",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Nota Técnica"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
    {
      "key": "9",
      "buttonName": "Outro",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Outro"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
  ];

  const menuDropdown =
    (
      <Menu>
        {jsonDropdownMenu.map((e, _) => (
          <>
            <Menu.Item
              defaultChecked={false}
              key={e.key}
              id={e.key}
              style={{ textAlign: "left" }}
              onClick={() => {
                controleDaGrid(e.buttonName);
                setCampos(e.campos)
              }}
            >
              {e.buttonName}
            </Menu.Item><Divider style={{ marginTop: 0, marginBottom: 0 }} /></>
        ))}
      </Menu>
    )

  nomeArquivo = campoDefaultValue("nmDocumento")?.toUpperCase()||"";
  return (
    <>
      <Dropdown overlay={menuDropdown} >
        <Button
          style={{ display: manter === 9 ? "none" : exibirElementoAcaoAlteracao }}
          id="incluirDocumento"
          type="primary"
          shape="round"
          icon={<PlusOutlined />}
        >
          Incluir Documento
        </Button>
      </Dropdown>
      <>

        <Modal title="Documento" open={exibirModalDoc}
          style={{ top: 20 }}
          destroyOnHidden={true}
          onCancel={() => {
            controleDaGrid("cancelar");
            form.resetFields([
              "idCertificadoraDocumento",
              "nmDocumento",
              "arquivo",
            ]);
          }}
          closable={false}
          cancelText="Cancelar"
          cancelButtonProps={{ shape: "round", icon: <CloseOutlined /> }}

          onOk={() => {
            validarDoc();
          }}
          okText="Incluir"
          okButtonProps={{ disabled: !chave, shape: "round", icon: <CheckOutlined /> }}
        >
          <Row>
            <Col xs={24} sm={24}
              style={{ display: hasCampo("nmDocumento") ? 'inline' : 'none' }}
            >
              <Form.Item label="Nome Documento"
                name="nmDocumento"
                colon={false}
                rules={[
                  {
                    required: isCampoRequired("nmDocumento"),
                    message: "Campo Nome do Documento obrigatório não preenchido",
                  },
                ]}
              >
                <Input disabled={isCampoDisabled("nmDocumento")} placeholder="Digitar Nome" defaultValue={campoDefaultValue("nmDocumento")} />
              </Form.Item>
            </Col>

          </Row>

          <Row justify="space-between">
            <Col xs={24} md={12} xl={5}>
              <SelecionarArquivo
                setChave={setChave}
                identificador={true}
              />
            </Col>

          </Row>

        </Modal>

      </>

      <Row style={{ display: exibirDocCadastrado }}>
        <Col
          xs={24}
          sm={24}
        >
          <Table
            size="small" columns={columns} dataSource={documentos} pagination={false} />
        </Col>
      </Row>
    </>
  )
};

export default CertificadorasDocumentos;